"use client";

import { useEffect } from "react";

import { initializeStoreFromContext } from "@/app/store";
import type { ActionSessionContext } from "@/app/actions";

export interface UserManagerProps {
	initialSessionContext: ActionSessionContext;
}

/**
 * User Manager initializer
 * Initializes Zustand stores with server-fetched session context
 */
export function UserManager({ initialSessionContext }: UserManagerProps): null {
	useEffect(() => {
		// Initialize stores immediately with server-fetched data
		initializeStoreFromContext(initialSessionContext);
	}, [initialSessionContext]);

	return null;
}
